// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"38":"ba351048665db8d8","440":"c6b1aecb48ed02e9","581":"6096171ea303e926"}[chunkId] + ".js";
};